/* eslint-disable @typescript-eslint/no-unused-vars */
import SearchInput from 'common/components/SearchInput';
import useSearch from 'common/hooks/useSearch';
import ClientResponseProps from 'common/types/UserResponseProps';
import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as FilterIcon } from 'common/icons/filter.svg';
import { ReactComponent as SortIcon } from 'common/icons/sort.svg';
import { ReactComponent as PlusIcon } from 'common/icons/plus.svg';
import IconButton from 'common/components/IconButton';
import useScreenSize from 'common/hooks/useScreenSize';
import { useClientsPerPage } from 'pages/CreateOrderPage/hooks/useClientsPerPage';
import { Avatar, Radio } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
//import { v4 as uuidv4 } from 'uuid';
import Pagination from 'common/components/Pagination';
import { useAuth } from 'common/context/AuthContext';
import { useFetchClients } from 'pages/CreateOrderPage/hooks/useFetchClients';
import Button from 'common/components/Button';
import { UserLineHover, UserLineWrapper, SidebarWrapper, SidebarCategoryWrapper, SidebarCategoryScroller, CategoryButton, SidebarInfoWrapper, ContentContainer } from 'pages/CreateOrderPage/styles/CreateOrderStyles';
import { stringAvatar } from 'common/utils/stringToColor';
import styled from '@emotion/styled';
import sendFetch from 'common/utils/fetch';

type UserLineProps = {
  user?: ClientResponseProps;
  selected?: number | string;
  setSelected?: React.Dispatch<React.SetStateAction<ClientResponseProps>>;
  isChangeable?: boolean;
  clearItems?: () => void;
};

type FirmLineProps = {
  id: string | number;
  name: string;
};

// const firmMockList: FirmLineProps[] = [
//   { id: 1, name: 'Firm A' },
//   { id: 2, name: 'Firm B' },
//   { id: 3, name: 'Firm C' },
//   { id: 4, name: 'Firm D' },
//   { id: 5, name: 'Firm E' },
//   { id: 6, name: 'Firm F' },
//   { id: 7, name: 'Firm G' },
//   { id: 8, name: 'Firm H' },
//   { id: 9, name: 'Firm I' },
//   { id: 10, name: 'Firm J' },
//   { id: 11, name: 'Firm K' },
//   { id: 12, name: 'Firm L' },
//   { id: 13, name: 'Firm M' },
//   { id: 14, name: 'Firm N' },
//   { id: 15, name: 'Firm O' },
//   { id: 16, name: 'Firm P' },
//   { id: 17, name: 'Firm Q' },
//   { id: 18, name: 'Firm R' },
//   { id: 19, name: 'Firm S' },
//   { id: 20, name: 'Firm T' },
//   { id: 21, name: 'Firm U' },
// ];

type PriceListDataProps = {
  id: string | number;
  name: string;
};

const mockPriceListData: PriceListDataProps[] = [
  { id: 1, name: 'Price List A' },
  { id: 2, name: 'Price List B' },
  { id: 3, name: 'Price List C' },
  { id: 4, name: 'Price List D' },
  { id: 5, name: 'Price List E' },
  { id: 6, name: 'Price List F' },
  { id: 7, name: 'Price List G' },
  { id: 8, name: 'Price List H' },
  { id: 9, name: 'Price List I' },
  { id: 10, name: 'Price List J' },
  { id: 11, name: 'Price List K' },
  { id: 12, name: 'Price List L' },
  { id: 13, name: 'Price List M' },
  { id: 14, name: 'Price List N' },
  { id: 15, name: 'Price List O' },
  { id: 16, name: 'Price List P' },
  { id: 17, name: 'Price List Q' },
  { id: 18, name: 'Price List R' },
  { id: 19, name: 'Price List S' },
  { id: 20, name: 'Price List T' },
  { id: 21, name: 'Price List U' },
];

const FirmContainer = styled.div`
    display:flex;
    gap: 8px;
    height: 68px;
    padding: 0 16px;
    align-items: center;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.gray};
    border-radius: 8px;
    flex: 1 0 auto;
    max-width: calc(50% - 8px);
`;

type FirmCardProps = {
  firm: FirmLineProps;
  selected: number | string;
  setSelected: React.Dispatch<React.SetStateAction<string | number>>;
  isChangeable: boolean;
  clearItems: () => void;
};

const FirmCard = ({ firm, selected, setSelected, isChangeable, clearItems }: FirmCardProps) => {
  const handleClick = () => {
    if (selected !== firm.id) {
      if (isChangeable) {
        setSelected(firm.id);
      } else {
        clearItems();
      }
    }
  };
  return (
        <FirmContainer onClick={handleClick} className={firm.id === selected ? 'active' : ''}>
            <Radio checked={firm.id === selected} />
            <p>{firm.name}</p>
        </FirmContainer>
  );
};

const generateFirmLines = (firmList: FirmLineProps[], selected: number | string, setSelected: React.Dispatch<React.SetStateAction<string | number>>, page: number, clientsPerPage: number, isChangeable: boolean, clearItems: () => void) => {
  const firmLinesPerPage = clientsPerPage * 2;
  const pageList = firmList.slice((page - 1) * firmLinesPerPage, page * firmLinesPerPage);
  const firmLines = [];
  for (let i = 0; i < pageList.length; i += 2) {
    firmLines.push(
            <div key={i} className='order-firm-line'>
                <FirmCard clearItems={clearItems} isChangeable={isChangeable} firm={pageList[i]} selected={selected} setSelected={setSelected} />
                {pageList[i + 1] && <FirmCard isChangeable={isChangeable} clearItems={clearItems} firm={pageList[i + 1]} selected={selected} setSelected={setSelected} />}
            </div>,
    );
  }
  return firmLines;
};

const UserLine = ({ user, selected, setSelected, isChangeable, clearItems }: UserLineProps) => {
  const handleClick = () => {
    if (selected !== user.id) {
      if (isChangeable) {
        setSelected(user);
      } else {
        clearItems();
      }
    }
  };
  return (
        <UserLineHover onClick={handleClick} className={user.id === selected ? 'active' : ''}>
            <UserLineWrapper>
                <Avatar {...stringAvatar(user.companyNumber ? user.companyName : `${user.lastName} ${user.firstName}`)} />
                <span className='find-user-line-name'>
                    {user?.companyNumber ? user.companyName : `${user?.lastName} ${user?.firstName[0]}.${user?.patronymic ? user?.patronymic[0] + '.' : ''}`}
                </span>
            </UserLineWrapper>
        </UserLineHover>
  );
};

type FindClientPageProps = {
  setStage: React.Dispatch<React.SetStateAction<number>>;
  client: ClientResponseProps | null;
  setClient: React.Dispatch<React.SetStateAction<ClientResponseProps | null>>;
  firm: string;
  setFirm: React.Dispatch<React.SetStateAction<string>>;
  priceList: string;
  setPriceList: React.Dispatch<React.SetStateAction<string>>;
  setPageType: React.Dispatch<React.SetStateAction<string>>;
  setOrderId: React.Dispatch<React.SetStateAction<string>>;
  setMaxStage: React.Dispatch<React.SetStateAction<number>>;
  isChangeable: boolean;
  setIsChangeable: React.Dispatch<React.SetStateAction<boolean>>;
  setFirmName: React.Dispatch<React.SetStateAction<string>>;
  setPriceListName: React.Dispatch<React.SetStateAction<string>>;
  clearItems: () => void;
};

// const generateClientList = (count: number) => {
//   const list: ClientResponseProps[] = [];
//   for (let i = 0; i < count; i++) {
//     const id = uuidv4(); 
//     const randomName = Math.random().toString(36).substring(7);
//     const randomLastName = Math.random().toString(36).substring(7);
//     const randomPatronymic = Math.random().toString(36).substring(7);

//     list.push({
//       id,
//       firstName: randomName,
//       lastName: randomLastName,
//       patronymic: randomPatronymic,
//       companyName: `Company ${i}`,
//       companyNumber: Math.random() > 0.6 ? '1234567890' : null,
//       country: 'Ukraine',
//       city: 'Kyiv',
//       region: 'Kyiv',
//       address: 'Street 1',
//       phoneNumber: '+380123456789',
//       email: 'example@gmail.com',
//     });
//   }
//   return list;
// };

export default function FindClientPage({ setFirmName, setPriceListName, isChangeable, setIsChangeable, clearItems, setPageType, setStage, setMaxStage, client, setClient, firm, setFirm, priceList, setPriceList, setOrderId }: FindClientPageProps) {
  const { companyId } = useAuth();
  const [category, setCategory] = useState('clients');
  const { searchValue, onSearchChange, clearSearch } = useSearch();
  const [searchVal, setSearchVal] = useState('' as string);
  const { clientList, fetchClients } = useFetchClients(searchVal, companyId);
  const [firmList, setFirmList] = useState<FirmLineProps[]>([]); // TODO: replace with real data from api
  const [priceListData, setPriceListData] = useState<PriceListDataProps[]>(mockPriceListData); // TODO: replace with real data from api
  // TODO: Add error and loading
  const { height } = useScreenSize();
  const listRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchClients();
  }, [searchValue, companyId]);


  const changeCategory = (e: React.MouseEvent<HTMLButtonElement>) => {
    const target = e.target as HTMLButtonElement;
    clearSearch();
    setSearchVal('');
    setPage(1);
    setCategory(target.name);
  };

  useEffect(() => {
    const fetchFirmList = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/get-nomenclature/get-departments',
        {
          method: 'GET',
        },
      );
      if (response && response[0] === 200 && response[1].statusCode === 200) {
        setFirmList(response[1].list);
      }
    };
    const fetchPriceList = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const response: any = await sendFetch('https://api-workspace.astin.net/api/get-nomenclature/get-prices',
        {
          method: 'GET',
        },
      );
      if (response && response[0] === 200 && response[1].statusCode === 200) {
        if (response[1].list.length > 0) {
          setPriceListData(response[1].list);
        }
      }
    };
    fetchFirmList();
    fetchPriceList();
  }, [companyId]);

  // get how many clients can fit in one page of the list by the list height and client height (for now 68px) but make it a variable
  const clientsPerPage = useClientsPerPage(listRef, height);
  console.log(clientList);
  console.log(clientsPerPage);
  let pageCount = 0;
  let pageList: ClientResponseProps[] = [];
  if (category === 'clients') {
    pageCount = Math.ceil(clientList.length / clientsPerPage?.clients);
    pageList = clientList.slice((page - 1) * clientsPerPage?.clients, page * clientsPerPage?.clients);
  } else if (category === 'firm') {
    // Firm list has two firms in a line
    pageCount = Math.ceil(firmList.length / (clientsPerPage?.lineCards * 2));
  } else if (category === 'price-list') {
    // Price list has two price lists in a line
    pageCount = Math.ceil(priceListData.length / (clientsPerPage?.lineCards * 2));
  }
  const handleCreateOrder = async () => {
    const formData = new FormData();
    formData.append('clientId', client?.id ? client.id.toString() : '');
    formData.append('companyId', companyId);
    formData.append('priceListId', priceList);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await sendFetch('https://api-workspace.astin.net/api/order/create-order',
      {
        method: 'POST',
        data: formData,
      },
    );
    console.log(response);
    if (response && response[0] === 200 && response[1].statusCode === 200) {
      setOrderId(response[1].id);
      setStage(2);
      setIsChangeable(false);
      setMaxStage(2);
    }
  };
  const canProceed = () => {
    return Boolean(client && firm && priceList);
  };
  const getErrorFields = () => {
    const fields = [];
    if (!client) {
      fields.push('Клієнти');
    }
    if (!firm) {
      fields.push('Пункт прийому');
    }
    if (!priceList) {
      fields.push('Прайс-лист');
    }
    return fields.join(', ');
  };
  const handleContinueButtonClick = () => {
    if (canProceed()) {
      clearSearch();
      // Initiate order
      if (isChangeable === true) {
        handleCreateOrder();
      }
    }
  };

  const handleCreateClientButtonClick = () => {
    setPageType('create-client');
  };

  // on firm change setFirmName
  useEffect(() => {
    if (firm) {
      const firmName = firmList.find((firmItem) => firmItem.id === firm)?.name;
      if (firmName) {
        setFirmName(firmName);
      }
    }
  }, [firm, firmList, setFirmName]);

  // on price list change setPriceListName
  useEffect(() => {
    if (priceList) {
      const priceListName = priceListData.find((priceListItem) => priceListItem.id === priceList)?.name;
      if (priceListName) {
        setPriceListName(priceListName);
      }
    }
  }, [priceList, priceListData, setPriceListName]);

  return (
        <div className='order-content-container'>
            <div className='order-content-wrapper'>
                <div className='order-content-half'>
                    <SidebarWrapper>
                        <SidebarCategoryWrapper>
                            <SidebarCategoryScroller>
                                <h3 className='new-h3 order-category-title'>Параметри</h3>
                                <CategoryButton onClick={changeCategory} className={category === 'clients' ? 'active' : ''} name='clients'>
                                    Клієнти
                                  {client && <CheckIcon fontSize="inherit" />}
                                </CategoryButton>
                                <CategoryButton disabled={!client} onClick={changeCategory} className={category === 'firm' ? 'active' : ''} name='firm'>
                                    Пункт прийому
                                  {firm && <CheckIcon fontSize="inherit" />}
                                </CategoryButton>
                                <CategoryButton disabled={!client} onClick={changeCategory} className={category === 'price-list' ? 'active' : ''} name='price-list'>
                                    Прайс-лист
                                  {priceList && <CheckIcon fontSize="inherit" />}
                                </CategoryButton>
                            </SidebarCategoryScroller>
                        </SidebarCategoryWrapper>
                        <SidebarInfoWrapper>
                            <h3 className='new-h3 order-category-title find-client-info-title'>Інформація про клієнта</h3>
                            <div className='find-client-info-list u-fancy-scrollbar'>
                                {!client ? (
                                    <div className='find-client-info-no-client order-subtext gray-text'>Виберіть клієнта для відображення короткої інформації</div>
                                ) : (
                                    <>
                                        <div className='find-client-info-line'>
                                            <p className='find-client-info-line-title'>Тип особи</p>
                                            <p className='find-client-info-line-value'>{client.companyNumber ? 'Юридична особа' : 'Фізична особа'}</p>
                                        </div>
                                        <div className='find-client-info-line'>
                                            <p className='find-client-info-line-title'>{client.companyNumber ? 'Найменування' : 'ПІБ'}</p>
                                            <p className='find-client-info-line-value'>
                                                {client.companyNumber ? client.companyName : `${client.lastName} ${client.firstName[0]}.${client.patronymic ? client.patronymic[0] + '.' : ''}`}
                                            </p>
                                        </div>
                                        {client.country && (
                                            <div className='find-client-info-line'>
                                                <p className='find-client-info-line-title'>Країна</p>
                                                <p className='find-client-info-line-value'>{client.country}</p>
                                            </div>
                                        )}
                                        {client.city && (
                                            <div className='find-client-info-line'>
                                                <p className='find-client-info-line-title'>Місто</p>
                                                <p className='find-client-info-line-value'>{client.city}</p>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </SidebarInfoWrapper>
                    </SidebarWrapper>
                    {category === 'clients' && <ContentContainer>
                        <div className='find-client-top-line'>
                            <span className='big-text'>
                                Клієнти
                            </span>
                            <span className='order-subtext gray-text'>
                                Оберіть клієнта для заповнення наступних параметрів
                            </span>
                        </div>
                        <div className='order-content-search-line'>
                            <div className='order-content-search-wrapper'>
                                <SearchInput wrapperStyle={{ flex: '1 0 auto' }} style={{ width: '100%' }} value={searchVal} onChange={(value: string) => { setSearchVal(value); }} searchFunction={onSearchChange} />
                                <IconButton>
                                    <FilterIcon className='svg-black' />
                                </IconButton>
                                <IconButton>
                                    <SortIcon className='svg-black' />
                                </IconButton>
                            </div>
                            <IconButton onClick={handleCreateClientButtonClick}>
                                <PlusIcon className='svg-black' />
                            </IconButton>
                        </div>
                        <div className='find-user-list-wrapper'>
                            <div ref={listRef} className='find-user-list'>
                                {pageList.map((user) => (
                                    <UserLine clearItems={clearItems} isChangeable={isChangeable} key={user.id} user={user} selected={client?.id || null} setSelected={setClient} />
                                ))
                                }
                            </div>
                        </div>
                        <div className='order-pagination-wrapper'>
                            {pageCount >= 2 && <Pagination count={pageCount} page={page} setPage={setPage} />}
                        </div>
                    </ContentContainer>}
                    {category === 'firm' &&
                        <ContentContainer>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Фірма / Філіали
                                </span>
                                <span className='order-subtext gray-text'>
                                    Обов’язковий параметр
                                </span>
                            </div>
                            {/*<div className='order-content-search-line'>
                                <div className='order-content-search-wrapper'>
                                    <SearchInput wrapperStyle={{ flex: '1 0 auto' }} style={{ width: '100%' }} value={searchVal} onChange={(value: string) => { setSearchVal(value); }} searchFunction={onSearchChange} />
                                </div>
                            </div>*/}
                            <div className='find-user-list-wrapper'>
                                <div ref={listRef} className='order-firm-list'>
                                    {generateFirmLines(firmList, firm || null, setFirm, page, clientsPerPage?.lineCards, isChangeable, clearItems)}
                                </div>
                            </div>
                            <div className='order-pagination-wrapper'>
                                {pageCount >= 2 && <Pagination count={pageCount} page={page} setPage={setPage} />}
                            </div>
                        </ContentContainer>
                    }
                    {category === 'price-list' &&
                        <ContentContainer>
                            <div className='find-client-top-line'>
                                <span className='big-text'>
                                    Прайс-лист
                                </span>
                                <span className='order-subtext gray-text'>
                                    Обов’язковий параметр
                                </span>
                            </div>
                            {/*<div className='order-content-search-line'>
                                <div className='order-content-search-wrapper'>
                                    <SearchInput wrapperStyle={{ flex: '1 0 auto' }} style={{ width: '100%' }} value={searchVal} onChange={(value: string) => { setSearchVal(value); }} searchFunction={onSearchChange} />
                                </div>
                            </div>*/}
                            <div className='find-user-list-wrapper'>
                                <div ref={listRef} className='order-firm-list'>
                                    {generateFirmLines(priceListData, priceList || null, setPriceList, page, clientsPerPage?.lineCards, isChangeable, clearItems)}
                                </div>
                            </div>
                            <div className='order-pagination-wrapper'>
                                {pageCount >= 2 && <Pagination count={pageCount} page={page} setPage={setPage} />}
                            </div>
                        </ContentContainer>
                    }
                </div>
                <div className='order-button-wrapper'>
                  <div className='proceed-button-with-error-wrapper'>
                    <Button disabled={!canProceed()} onClick={handleContinueButtonClick} primary label='Продовжити' />
                    {!canProceed() && <span className="error">Будь ласка оберіть поля: {getErrorFields()}</span>}
                  </div>
                </div>
            </div>
        </div>
  );
}